import { render, staticRenderFns } from "./DrugAdd.vue?vue&type=template&id=2390e4f4&scoped=true&"
import script from "./DrugAdd.vue?vue&type=script&lang=js&"
export * from "./DrugAdd.vue?vue&type=script&lang=js&"
import style0 from "./DrugAdd.vue?vue&type=style&index=0&id=2390e4f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2390e4f4",
  null
  
)

export default component.exports